// extracted by mini-css-extract-plugin
export default {"searchPanel":"Search_searchPanel__e4Woj","submit":"Search_submit__zY7AM","reset":"Search_reset__rlPQJ","field":"Search_field__CWO4v"};